var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85522 11.75V9.97729H10.7895C11.1172 9.97729 11.5132 10.2983 11.5132 10.8636C11.5132 11.429 11.1172 11.75 10.7895 11.75H7.85522Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85522 15.0227V13.25H11.5263C11.8541 13.25 12.25 13.571 12.25 14.1364C12.25 14.7017 11.8541 15.0227 11.5263 15.0227H7.85522Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5C2 16.6421 5.35786 20 9.5 20H18C20.2091 20 22 18.2091 22 16C22 13.7909 20.2091 12 18 12C17.6514 12 17.3133 12.0446 16.991 12.1284C16.7973 8.15887 13.5175 5 9.5 5C5.35786 5 2 8.35786 2 12.5ZM8.59211 8V8.47727H8.93421V8C8.93421 7.58579 9.27 7.25 9.68421 7.25C10.0984 7.25 10.4342 7.58579 10.4342 8V8.47727H10.7895C12.0895 8.47727 13.0132 9.62149 13.0132 10.8636C13.0132 11.3032 12.8975 11.7305 12.6904 12.0991C13.3436 12.5315 13.75 13.3124 13.75 14.1364C13.75 15.3785 12.8264 16.5227 11.5263 16.5227H10.4342V17C10.4342 17.4142 10.0984 17.75 9.68421 17.75C9.27 17.75 8.93421 17.4142 8.93421 17V16.5227H8.59211V17C8.59211 17.4142 8.25632 17.75 7.84211 17.75C7.42789 17.75 7.09211 17.4142 7.09211 17V16.5227H6C5.58579 16.5227 5.25 16.1869 5.25 15.7727C5.25 15.3585 5.58579 15.0227 6 15.0227H6.35526V9.97727H6C5.58579 9.97727 5.25 9.64149 5.25 9.22727C5.25 8.81306 5.58579 8.47727 6 8.47727H7.09211V8C7.09211 7.58579 7.42789 7.25 7.84211 7.25C8.25632 7.25 8.59211 7.58579 8.59211 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinCloud);
export default __webpack_public_path__ + "static/media/bitcoin-cloud.9a53f171ab5c4f48c7d9d6156d5426b4.svg";
export { ForwardRef as ReactComponent };